import api from '__jsVueApi';

export default {
	async loadListOfDeals({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.deals.get, {
				params: {
					expand:    ['major_market.region']
				}
			})
			.then(response => {
				commit('setListOfDeals', response.data);
			})
			.catch(err => {
				commit('main/setLoad', false, { root: true });
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
	async loadListOfPublicDeals({ state, commit }, peyload) {
		let options = (peyload) || ({
			load: true
		});
		if (options.load !== false) {
			commit('main/setLoad', true, { root: true });
		}
		let pageSize = 12;
		await axios
			.get(api.publicDeals.get, {
				params: {
					search_by:    state.search.search,
					q:            (state.search.search !== 'market' || !state.search.major_market) ? (state.search.str) : (state.search.major_market),
					order_by:     state.search.order,
					page_size:    pageSize,
					page:         state.page,
					expand:       ['major_market.region']
				}
			})
			.then(response => {
				commit('setListOfPublicDeals', response.data.results);
				commit('setPages', Math.ceil(response.data.count / pageSize));
			})
			.catch(err => {
				commit('main/setLoad', false, { root: true });
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
	async makePrivateDeal({ state, rootState, commit }, id) {
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		commit('main/setLoad', true, { root: true });
		await axios
			.post(api.publicDeals.makePrivate(id), {
				is_public: false,
			})
			.then(response => {

			})
			.catch(err => {
				commit('main/setLoad', false, { root: true });
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},
	async loadListOfSuccessStories({ state, commit }, peyload) {
		let options = (peyload) || ({
			load: true
		});
		if (options.load !== false) {
			commit('main/setLoad', true, { root: true });
		}
		let pageSize = 12;
		await axios
			.get(api.successStories.get, {
				params: {
					search_by:    state.search.search,
					q:            (state.search.search !== 'market' || !state.search.major_market) ? (state.search.str) : (state.search.major_market),
					order_by:     state.search.order,
					page_size:    pageSize,
					page:         state.page,
					expand:       ['major_market.region']
				}
			})
			.then(response => {
				commit('setListOfSuccessStories', response.data.results);
			})
			.catch(err => {
				commit('main/setLoad', false, { root: true });
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},

	async loadVideoGuides({ state, rootState, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.admin.videoGuides.get)
			.then(response => {
				commit('setVideoGuides', response.data);
			})
			.catch(err => {
				commit('main/setLoad', false, { root: true });
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},

	async updateVideoGuides({ state, rootState, commit }, payload) {
		axios.defaults.headers[rootState.main.header.name] = rootState.main.header.value;
		commit('main/setLoad', true, { root: true });
		commit('setVideoGuidesError', []);
		await axios
			.post(api.admin.videoGuides.post, payload)
			.catch(err => {
				commit('main/setLoad', false, { root: true });
				commit('setVideoGuidesError', err.response.data);
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	},

	async loadSubscriptionList({ state, commit }) {
		commit('main/setLoad', true, { root: true });
		await axios
			.get(api.subscriptionList.get)
			.then((response) => {
				commit('setSubscriptionList', response.data);
			})
			.catch((err) => {
				throw new Error(err);
			});
		commit('main/setLoad', false, { root: true });
	}

};
